import React from 'react'
import PaymentTransactionListTable from './Components/PaymentTransactionListTable'
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const PaymentTransactionList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Payment Transaction List</HeadingOne>
        </>
      }>

      {/* Table section */}
      <div className="col-12">
        <PaymentTransactionListTable />
      </div>
    </PageBody>
  );
};

export default PaymentTransactionList;
